import React from "react";

import { SpinnerAnimation, SpinnerContainer, SpinnerIcon } from "./styles";

export type SpinnerProps = {
  className?: string;
  height?: string;
  size?: number;
};

export const Spinner = ({ className, height, size = 64 }: SpinnerProps) => {
  return (
    <SpinnerContainer
      className={className}
      height={height}
      aria-busy="true"
      role="alert"
      aria-label="loading"
      data-testid="spinner"
    >
      <SpinnerAnimation dimensions={size}>
        <SpinnerIcon dimensions={size} />
      </SpinnerAnimation>
    </SpinnerContainer>
  );
};
